module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"sub_title":"購物車商品列表"}}')
  delete Component.options._Ctor
}
